/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationApi } from '../../sdk/services';
import { findIndex as _find } from 'lodash';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-link-organization-dialog',
  templateUrl: './link-organization-dialog.component.html',
  styleUrls: ['./link-organization-dialog.component.scss'],
})
export class LinkOrganizationDialogComponent implements OnInit {
  organizations: Array<any> = [];
  items = new Array<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LinkOrganizationDialogComponent>,
    private organizationApi: OrganizationApi,
    private notificationService: NotificationService
  ) {
  }

  ngOnInit() {
    // Fetch All Companies
    this.organizationApi.list().toPromise().then((response: any) => {
      this.items = response;
      // Push Selected
      this.data.entities.forEach((item) => {
        // Find Matching ID
        const id = _find(this.items, function (o) { return o.id === item.id; });
        this.organizations.push(this.items[id]);
      });
    }).catch(this.notificationService.errorHandler);
  }

  confirmSelection() {
    this.dialogRef.close(this.organizations);
  }

}

